// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { YYYYMMDDtoEpoch } from 'helpers/timeConversion'

import {
  castToBool,
  castToFloat,
} from 'helpers/reduxFormFunctions'

// we'll cast all these to boolean
const cb = [
  'acap',
  'accp',
  'atpcFlag',
  'dynamicPowerFlag',
  'xpic',
]

// we'll cast all these to floats
const ci = [
  'architectureId',
  'atpcTypeId',
  'duplexModeId',
  'extNarrowBwFilter',
  'hiFrequency',
  'loFrequency',
  'modulationTypeId',
  'modulationLimit',
  'powerTypeId',
  'radioTypeId',
  'stabilityId',
  'statusId',
  'radioId',
]

const prepRadioData = (d, radioModulations) => {
  const {
    companyId,
    radioCode,
    radioFamilyId,
  } = d

  // to support new modulations, a fake radioModulationId is assigned.
  // the fake id will be of the following pattern: `temp-modulation-id-${Date.now()}`
  // See formatModulationData.js for where this is created.
  // casting the radioModulationId to float will make the temp ids become null
  // and set the radioModulationId as an integer for the existing ones.
  radioModulations.forEach(m => {
    m.radioModulationId = castToFloat(m.radioModulationId)
  })

  const r = {
    companyId,
    radioCode,
    radioFamilyId,
    radioModulations,
  }

  cb.forEach(s => { r[s] = castToBool(d[s]) })
  ci.forEach(s => { r[s] = castToFloat(d[s]) })
  r.specDate = YYYYMMDDtoEpoch(d.specDate)

  return r
}

export default prepRadioData
